import script from "./listado.vue?vue&type=script&setup=true&lang=js"
export * from "./listado.vue?vue&type=script&setup=true&lang=js"

import "./listado.vue?vue&type=style&index=0&id=b1576e66&lang=scss"

const __exports__ = script;

export default __exports__